import Button from 'components/common/Button';
import Tooltip, { type PlacementOptions } from 'components/common/Tooltip';
import { FullCircleIcon, RefreshIcon } from 'components/common/Icons';

type AutoRefreshButtonProps = {
  isOn: boolean;
  onClick: (e: React.MouseEvent) => void;
  tooltipOn?: string;
  tooltipOff?: string;
  tooltipPlacement?: PlacementOptions;
};

export const AutoRefreshButton = ({
  isOn,
  onClick,
  tooltipOn = 'Disable Auto Refresh',
  tooltipOff = 'Enable Auto Refresh',
  tooltipPlacement = 'top',
}: AutoRefreshButtonProps) => {
  return (
    <Tooltip overlay={isOn ? tooltipOn : tooltipOff} placement={tooltipPlacement}>
      <Button
        className="flex"
        size="small"
        color={isOn ? 'success' : 'default'}
        variant="accented"
        onClick={onClick}
        leftIcon={isOn ? <FullCircleIcon /> : <RefreshIcon />}
        data-test-id="auto-refresh-button"
      >
        <span className="old-text-xs color-text-primary">Auto Refresh</span>
      </Button>
    </Tooltip>
  );
};
